import { Inline } from '@bedrock-layout/primitives';
import styled from 'styled-components';

export const CreateConnector = styled(Inline)`
  background-color: var(--color-white);
  cursor: pointer;
  color: var(--color-primary1);
`;
